import React, { useEffect } from "react";
import {
  makeStyles,
  Divider,
  Container,
  Box,
  Card,
  CardContent,
  CardHeader,
} from "@material-ui/core";

import MaterialTable from "material-table";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { AlertTitle, Alert } from "@material-ui/lab";
import _ from "lodash";
import { hasRole } from "src/utils/Auth";
import {
  fetchCurrencies,
  findAllBrand,
  findAllDepartment,
  getAllCountries,
} from "src/redux/actions/reference.action";
import Page from "src/components/Page";
import { httpClient } from "src/utils/HttpClient";
import { apiUrl } from "src/Constants";
import moment from "moment";
import StatusLabel from "src/components/StatusLabel";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
  },
}));

const PRListApproverPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    result: { countryid, currencyid, brand_id, department_id, perid },
  } = useSelector((state) => state.loginReducer);

  const { purchaseRequests } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  const { authorizePR } = useSelector((state) => state.authorizationReducer);
  const { allDepartments, allBrands } = useSelector(
    (state) => state.referenceReducer
  );

  useEffect(() => {
    dispatch(getAllCountries());
    dispatch(fetchCurrencies(currencyid));
    dispatch(findAllDepartment());
    dispatch(findAllBrand());
  }, []);

  if (purchaseRequests.isRejected) {
    return (
      <div className={classes.root}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          This is an error alert —{" "}
          <strong>Get Purchase Requisition data!</strong>
        </Alert>
      </div>
    );
  }

  const renderLookupBrand = () => {
    if (allBrands.data) {
      let obj = allBrands.data.reduce(function (acc, cur, i) {
        acc[cur.REF_ID] = cur.REF_NAME;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  const renderLookupDepartment = () => {
    if (allDepartments.data) {
      let obj = allDepartments.data.reduce(function (acc, cur, i) {
        acc[cur.REF_ID] = cur.REF_NAME;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  return (
    <Page className={classes.root} title="Contract Search">
      <Container maxWidth={false}>
        <Card>
          <CardHeader subheader="" title="Contract Search" />
          <Divider />
          <CardContent>
            <Box display="flex" flexDirection="column">
              <Box flexGrow={1}>
                <MaterialTable
                  title
                  isLoading={purchaseRequests.isLoading}
                  columns={[
                    {
                      title: "PR NO.",
                      field: "PR_NO",
                    },
                    {
                      title: "Brand",
                      field: "PR_BRANDID",
                      lookup: renderLookupBrand(),
                    },
                    {
                      title: "Department",
                      field: "PR_DEPARTID",
                      lookup: renderLookupDepartment(),
                    },
                    {
                      title: "Vender",
                      field: "VENDER",
                    },
                    { title: "Requester", field: "CREATED_NAME" },
                    {
                      title: "Status",
                      field: "PR_STATUS",
                      lookup: {
                        49: "CONTRACT IS REQUIRED",
                        51: "VERIFIED PR",
                        52: "LEGAL MAKES A DECISION",
                        54: "LEGAL IN PROGRESS ",
                        55: "FINAL DRAFT IS DONE AND READY TO SIGN OFF",
                        56: "CONTRACT IS ATTACHED",
                        57: "LEGAL TASK IS COMPLETED ",
                        58: "CONTRACT IS REJECTED",
                        59: "HELD BY LEGAL",
                      },
                      render: (rowData) => (
                        <StatusLabel status={rowData.PR_STATUS} />
                      ),
                    },
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      let url = `${apiUrl}/purchase-request/contract-legal-list?`;

                      url += "per_page=" + query.pageSize;
                      url += "&page=" + query.page;
                      url += "&search=" + query.search;

                      if (query.filters.length) {
                        query.filters.map(({ column, value }) => {
                          if (column.field === "CREATED_DATE") {
                            value = moment(value).format("YYYY-MM-DD");
                          }
                          url += `&${column.field}=${value}`;
                        });
                      }

                      if (query.orderBy) {
                        url += `&orderby=${query.orderBy.field},${query.orderDirection}`;
                      }

                      httpClient.get(url).then(({ data }) => {
                        resolve({
                          data: data.rows,
                          page: query.page,
                          totalCount: data.count,
                        });
                      });
                    })
                  }
                  actions={[
                    (rowData) => ({
                      icon: "edit",
                      onClick: (event, rowData) => {
                        event.preventDefault();
                        history.push(`create-contact/${rowData.PRHIDX}`);
                      },
                    }),
                  ]}
                  options={{
                    filtering: true,
                    search: true,
                    showFirstLastPageButtons: false,
                  }}
                  style={{
                    width: "100%",
                  }}
                />
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
};

export default PRListApproverPage;
